import { render, staticRenderFns } from "./incomeRecordList.vue?vue&type=template&id=a29b0cca&scoped=true"
import script from "./incomeRecordList.vue?vue&type=script&lang=ts"
export * from "./incomeRecordList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29b0cca",
  null
  
)

export default component.exports